/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const MonitorDot = [
  ["path", { d: "M12 17v4" }],
  ["path", { d: "M22 12.307V15a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h8.693" }],
  ["path", { d: "M8 21h8" }],
  ["circle", { cx: "19", cy: "6", r: "3" }]
];

export { MonitorDot as default };
//# sourceMappingURL=monitor-dot.js.map
